import { render } from "./PreciosIndex.vue?vue&type=template&id=36f00fe8"
import script from "./PreciosIndex.vue?vue&type=script&lang=js"
export * from "./PreciosIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__